import type {
  ExpenseThisMonthInsightsDTO,
  ExpenseThisMonthInsightItemDTO,
} from "../models/expenseThisMonthInsightsDto";
import type {
  ExpenseThisMonthInsightsEntity,
  ExpenseThisMonthInsightItemEntity,
} from "../../domain/entities/ExpenseThisMonthInsightsEntity";

function normalizeItem(
  item: ExpenseThisMonthInsightItemDTO,
): ExpenseThisMonthInsightItemEntity {
  const accent =
    item.accentColor === "success" || item.accentColor === "warning"
      ? item.accentColor
      : "neutral";
  return {
    title: item.title,
    description: item.description,
    accentColor: accent,
  };
}

export function expenseThisMonthInsightsDtoToEntity(
  dto: ExpenseThisMonthInsightsDTO,
): ExpenseThisMonthInsightsEntity {
  return {
    monthLabel: dto.monthLabel,
    insights: Array.isArray(dto.insights) ? dto.insights.map(normalizeItem) : [],
  };
}

